import { getTranslationKeyForZero } from './get_translation_key_for_zero';
import { getTranslationKeyForNotAvailable } from './get_translation_key_for_not_available';
import { getTranslationKeyForSameDayShipping } from './get_translation_key_for_same_day_shipping';
import { getTranslationKeyForNextDayShipping } from './get_translation_key_for_next_day_shipping';
import { getTranslationKeyDefault } from './get_translation_key_default';
import { LONG_TRANSLATION_KEY } from './constants';

export const getTranslationKeyByShippingTime = (
    shippingTime,
    shortVersion = LONG_TRANSLATION_KEY
) =>
    shippingTime === '0' || shippingTime === '0-0'
        ? getTranslationKeyForZero(shortVersion)
    
    : !shippingTime || shippingTime === 'N/A' || shippingTime === ''
        ? getTranslationKeyForNotAvailable(shortVersion)

    : shippingTime.match(/(~ 1)|(^0\s?-\s?1$)/)
        ? getTranslationKeyForSameDayShipping(shortVersion)

    : shippingTime.match(/(~ 2)|(^1\s?-\s?2$)/)
        ? getTranslationKeyForNextDayShipping(shortVersion)

    : getTranslationKeyDefault(shortVersion);
